import type { MouseEvent as ReactMouseEvent } from 'react'

/**
 * The modifier keys behind a click.
 *
 * `additive` folds ctrl and meta together: the same gesture is ctrl on Windows
 * and Linux and cmd on a Mac, and a surface reading only one of them works for
 * half its users.
 */
export type ClickModifiers = {
  /** Extend from the last click, the way a file manager does. */
  shift: boolean
  /** Add to the selection rather than replacing it. */
  additive: boolean
}

export function readClickModifiers(
  event: Pick<ReactMouseEvent, 'shiftKey' | 'ctrlKey' | 'metaKey'>,
): ClickModifiers {
  return {
    shift: event.shiftKey,
    additive: event.ctrlKey || event.metaKey,
  }
}
